import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import * as req from 'src/app/entities/request';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { FocusInputType, GeneralConfigType, HtmlBorderLine, HtmlStyle, HtmlStyleAlignment, HtmlStyleType, KeyValueSet, LocalService, NumericConfig, ReceiptOption, ReceiptOptionGroup, ReceiptType, Status } from 'src/service/local.service';
import { PrinterService } from 'src/service/printer.service';

@Component({
  selector: 'app-receipt-template-popup',
  templateUrl: './receipt-template-popup.component.html',
  styleUrl: './receipt-template-popup.component.scss'
})
export class ReceiptTemplatePopupComponent {
  @ViewChild('content_receipt_template') content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  @Input() itemId: string | undefined = undefined;
  @Input() businessId: string;
  @Input() ctryCode: string;

  numericConfig: NumericConfig = { isDecimalAllowed: true, isNegativeAllowed: true } as NumericConfig;

  receiptOptionsSource: KeyValueSet[] = [];
  receiptOptions: KeyValueSet[] = [];
  businessTypes: KeyValueSet[] = [];
  selectedKeys: string[] = [];
  title: string = '';
  paperSizes: KeyValueSet[];
  selectedKeyPaperSize: string; searchKey = ''; selectedBusinessTypes: string[] = [];
  marginLeft: number = 0; marginTop: number = 0; width: number = 0;
  isCustomerCopy: boolean = true;
  htmlStyles: HtmlStyle[] = [];

  htmlStyleOption: KeyValueSet[] = [
    { key: HtmlStyleType.ReceiptTop.toString(), value: 'Receipt Top' },
    { key: HtmlStyleType.ReceiptBottom.toString(), value: 'Receipt Bottom' }];
  htmlAlignmentOption: KeyValueSet[] = [
    { key: HtmlStyleAlignment.Center.toString(), value: 'Center' },
    { key: HtmlStyleAlignment.Left.toString(), value: 'Left' },
    { key: HtmlStyleAlignment.Right.toString(), value: 'Right' }];
  htmlBorderOption: KeyValueSet[] = [
    { key: HtmlBorderLine.None.toString(), value: 'None' },
    { key: HtmlBorderLine.All.toString(), value: 'All' },
    { key: HtmlBorderLine.Top.toString(), value: 'Top' },
    { key: HtmlBorderLine.Bottom.toString(), value: 'Bottom' }];

  selectedHtmlStyleType = HtmlStyleType.ReceiptTop.toString();
  selectedHtmlAlignmentType = HtmlStyleAlignment.Left.toString();
  selectedHtmlBorder = HtmlBorderLine.None.toString();
  selectedHtmlContent = ''; isHtmlStyleActive = false;
  selectedMarginTop: number = 0; selectedLineHeight: number = 0; selectedWidth: number = 0; selectedFontSize: number = 0; selectedIsBold: boolean = false;

  htmlId: string;
  elementIds: any;

  message: string = ''; isRedAlert: boolean = true;
  defultReceiptOptions: ReceiptOption[] = [ReceiptOption.CompanyName, ReceiptOption.CompanyContactNumber, ReceiptOption.CompanyAddress, ReceiptOption.DateTime, ReceiptOption.GrandTotal, ReceiptOption.CompanyLogo, ReceiptOption.ItemName, ReceiptOption.ItemQuantity, ReceiptOption.ItemTotalCost, ReceiptOption.QR_Code, ReceiptOption.ReceiptNumber, ReceiptOption.PaidAmount, ReceiptOption.TotalQuantity, ReceiptOption.UnitPrice, ReceiptOption.WelcomeMessage, ReceiptOption.ItemRow_2X3__1, ReceiptOption.ItemHeader_2X3__2, ReceiptOption.GSTIN, ReceiptOption.ProductTaxesRow, ReceiptOption.ProductTaxes, ReceiptOption.BusinessTaxesRow, ReceiptOption.BusinessTaxes];

  constructor(public localService: LocalService, private offcanvasService: NgbOffcanvas, private printerService: PrinterService, private configurationManagementService: ConfigurationManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      save_receipt_template: 'save-receipt-template-' + this.htmlId,
      receipt_options: 'receipt-options-' + this.htmlId,
      txt_search_key: 'txt_search_key-' + this.htmlId,
      margin_left: 'margin_left_' + this.htmlId,
      margin_top: 'margin_top_' + this.htmlId,
      width: 'width_' + this.htmlId,
    };
  }


  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onReset() {
    this.receiptOptionsSource = [];
    this.searchKey = '';
  }

  onLoad() {
    this.onReset();
    if (this.itemId) {
      const req = { BusinessId: this.businessId, CountryCode: this.localService.getLoginAsCountryCode() } as req.BusinessDetail;
      this.printerService.getPrinterTemplate(req, this.itemId).subscribe(result => {
        if (result.Mandatory.Status && result.Mandatory.Status == Status.Success) {
          this.title = result.Title;
          this.selectedKeys = result.Options.map(x => x.toString());
          this.selectedKeyPaperSize = result.PaperSize.toString();
          this.selectedBusinessTypes = result.BusinessTypes;
          this.marginLeft = result.MarginLeft ?? 0;
          this.marginTop = result.MarginTop ?? 0;
          this.width = result.Width ?? 0;
          this.htmlStyles = result.HtmlStyles ?? [];
          this.isCustomerCopy = result.IsCustomerCopy == true ? true : false;
          this.selectedHtmlStyleType = this.htmlStyles.length > 0 ? this.htmlStyles[0].type.toString() : HtmlStyleType.ReceiptTop.toString();
          this.onSelectHtmlStyleType();
          this.onCheckReceiptType();
        }
      });
    } else {
      this.title = '';
      this.selectedKeys = [];
      this.selectedKeyPaperSize = '';
      this.selectedBusinessTypes = [];
    }
    this.onFilter();
    this.onLoadOptions();
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        if (this.onDoCheck()) {
          const req = {
            BusinessId: this.businessId,
            CountryCode: this.localService.getLoginAsCountryCode(),
            Key: this.itemId, Title:
              this.title.trim(),
            PaperSize: parseInt(this.selectedKeyPaperSize),
            Options: this.selectedKeys.map(x => parseInt(x)).filter(x => x),
            BusinessTypes: this.selectedBusinessTypes,
            MarginLeft: this.marginLeft,
            MarginTop: this.marginTop,
            Width: this.width,
            IsCustomerCopy: this.isCustomerCopy,
            HtmlStyles: this.htmlStyles
          } as req.PrinterTemplate;
          this.printerService.savePrinterTemplate(req).subscribe(result => {
            this.localService.showInformationByStatus(result.status);
            if (result.status == Status.Success) {
              this.onCloseTrigger();

              let userReceiptTemplate = this.localService.loggedMember?.receiptTemplates?.find(x => x.id == this.itemId);
              if (userReceiptTemplate) {
                userReceiptTemplate.title = req.Title;
                userReceiptTemplate.options = req.Options;
                userReceiptTemplate.isCustomerCopy = req.IsCustomerCopy;
                userReceiptTemplate.receiptType = req.PaperSize;
              }
            }
          });
        }
      } break;
      case 2: {
        this.onFilter();
      } break;
      case 3: {
        //Update source
        this.onEnableDisableDuplicate();
        this.receiptOptionsSource.find(x => x.key == key).isSelected = this.receiptOptions.find(x => x.key == key).isSelected;
      } break;
    }
  }

  onFilter() {
    if (this.receiptOptionsSource) {
      const searchKey = this.searchKey.trim().toLowerCase();
      const items = searchKey != '' ? this.receiptOptionsSource.filter(x => x.key.indexOf(searchKey) > -1 || x.value.toLowerCase().indexOf(searchKey) > -1 || (x.s_value && x.s_value.indexOf(searchKey) > -1)) : this.receiptOptionsSource;
      this.receiptOptions = items.map(function (result) {
        return {
          key: result.key,
          value: result.value,
          isSelected: result.isSelected
        } as KeyValueSet;
      });
      this.onEnableDisableDuplicate();
      this.localService.onFocusNextInput(this.elementIds.txt_search_key, FocusInputType.TextBox);
    }
  }

  onLoadOptions() {
    const iConfigTypes: GeneralConfigType[] = [GeneralConfigType.ReceiptOption, GeneralConfigType.ReceiptType, GeneralConfigType.BusinessType];
    this.configurationManagementService.getConfigurationsToDisplayMulti(iConfigTypes, true).subscribe(result => {
      result.forEach(item => {
        switch (parseInt(item.key)) {
          case GeneralConfigType.ReceiptOption: {
            this.receiptOptionsSource = item.value;
            if (!this.itemId) {
              this.receiptOptionsSource.forEach(item => {
                item.isSelected = this.defultReceiptOptions.includes(parseInt(item.key));
              });
            } else {
              this.receiptOptionsSource.forEach(item => {
                item.isSelected = this.selectedKeys.includes(item.key);
              });
            }
            this.onFilter();
            this.onEnableDisableDuplicate();
          } break;
          case GeneralConfigType.ReceiptType: {
            this.paperSizes = item.value;
          } break;
          case GeneralConfigType.BusinessType: {
            this.businessTypes = item.value;
          } break;
        }
      });
    });
  }

  onDoCheck(): boolean {
    this.selectedKeys = this.receiptOptionsSource.filter(x => x.isSelected).map(x => x.key);
    let isPassed = true;
    let message = '';
    if (!this.title.trim()) {
      message = this.localService.languageContent.printer.titleRequired;
      isPassed = false;
    } else if (!this.selectedKeyPaperSize) {
      message = this.localService.languageContent.printer.paperSizeRequired;
      isPassed = false;
    } else if (this.selectedKeys.length == 0) {
      message = this.localService.languageContent.printer.minReceiptTemplateRequired;
      isPassed = false;
    }
    this.message = message;
    return isPassed;
  }

  onEnableDisableDuplicate() {
    const lstReceiptOptionGroups: number[] = Object.keys(ReceiptOptionGroup).map(x => parseInt(x)).filter(x => x || x == 0);
    const receiptOptionsTextsSelected = this.receiptOptions.filter(x => x.isSelected).map(receiptOption => ReceiptOption[parseInt(receiptOption.key)]);
    this.receiptOptions.filter(x => !x.isSelected).forEach(receiptOption => {
      const receiptOptionsText = ReceiptOption[parseInt(receiptOption.key)];
      lstReceiptOptionGroups.forEach(receiptOptionGroup => {
        const currentGroup = '__' + receiptOptionGroup;
        if (receiptOptionsText && receiptOptionsText.endsWith(currentGroup)) {
          receiptOption.isInActive = receiptOptionsTextsSelected.filter(x => x.endsWith(currentGroup)).length > 0;
        }
      });
    });
  }

  isFixReceiptType = false;
  onCheckReceiptType() {
    const receiptType = parseInt(this.selectedKeyPaperSize);
    const fixedReceiptType = Object.keys(ReceiptType).find(k => ReceiptType[k as keyof typeof ReceiptType] === receiptType);
    this.isFixReceiptType = fixedReceiptType?.startsWith("Fix_");
  }

  onSelectHtmlStyleType() {
    const item = this.htmlStyles.find(x => x.type.toString() == this.selectedHtmlStyleType);
    this.selectedHtmlAlignmentType = item?.align.toString() ?? HtmlStyleAlignment.Left.toString();
    this.selectedHtmlContent = item?.content ?? '';
    this.isHtmlStyleActive = item?.isActive ?? false;
    this.selectedHtmlBorder = item?.border.toString() ?? HtmlBorderLine.None.toString();
    this.selectedMarginTop = item?.marginTop ?? 0;
    this.selectedLineHeight = item?.lineHeight ?? 0;
    this.selectedWidth = item?.width ?? 0;
    this.selectedFontSize = item?.fontSize ?? 0;
    this.selectedIsBold = item?.isBold ?? false;
  }

  onSetHtmlStyle() {
    let item = this.htmlStyles.find(x => x.type.toString() == this.selectedHtmlStyleType);
    if (item) {
      item.align = parseInt(this.selectedHtmlAlignmentType);
      item.content = this.selectedHtmlContent;
      item.isActive = this.isHtmlStyleActive;
      item.border = parseInt(this.selectedHtmlBorder);
      item.marginTop = this.selectedMarginTop;
      item.lineHeight = this.selectedLineHeight;
      item.width = this.selectedWidth;
      item.fontSize = this.selectedFontSize;
      item.isBold = this.selectedIsBold;
    } else {
      this.htmlStyles.push({
        type: parseInt(this.selectedHtmlStyleType),
        align: parseInt(this.selectedHtmlAlignmentType),
        content: this.selectedHtmlContent,
        isActive: this.isHtmlStyleActive,
        border: parseInt(this.selectedHtmlBorder),
        marginTop: this.selectedMarginTop,
        lineHeight: this.selectedLineHeight,
        width: this.selectedWidth,
        fontSize: this.selectedFontSize,
        isBold: this.selectedIsBold,
      });
    }
  }
}
